import { createSelector } from "reselect";

const getSangerCosmicSchemaProperties = (state) =>
  state.schema &&
  state.schema.properties &&
  state.schema.properties.sanger_cosmic_licensed;

const getSangerCosmic = (state) =>
  state.variantResult && state.variantResult.sanger_cosmic;

const getSangerCosmicPublic = (state) =>
  state.variantResult && state.variantResult.sanger_cosmic_public;

const getSangerCosmicLicensed = (state) =>
  state.variantResult && state.variantResult.sanger_cosmic_licensed;

const getSangerCosmicLicensedVersion = createSelector(
  getSangerCosmicLicensed,
  (cosmic) => cosmic && cosmic[0].version
);

const getSangerCosmicLicensedItems = createSelector(
  getSangerCosmicLicensed,
  (cosmic) => cosmic && cosmic[0].items
);

const getSangerCosmicLicensedItem = createSelector(
  getSangerCosmicLicensed,
  (cosmic) => {
    let item = null;
    if (
      cosmic &&
      cosmic[0] &&
      cosmic[0].items[0] &&
      cosmic[0].items[0].num_entries &&
      cosmic[0].items[0].fathmm_prediction &&
      cosmic[0].items[0].histology_freq
    ) {
      // eslint-disable-next-line prefer-destructuring
      item = cosmic[0].items[0];
    } else if (
      cosmic &&
      cosmic[0] &&
      cosmic[0].items[1] &&
      cosmic[0].items[1].num_entries &&
      cosmic[0].items[1].fathmm_prediction &&
      cosmic[0].items[1].histology_freq
    ) {
      // eslint-disable-next-line prefer-destructuring
      item = cosmic[0].items[1];
    }
    return item;
  }
);

export {
  getSangerCosmicSchemaProperties,
  getSangerCosmic,
  getSangerCosmicPublic,
  getSangerCosmicLicensed,
  getSangerCosmicLicensedVersion,
  getSangerCosmicLicensedItems,
  getSangerCosmicLicensedItem,
};
